module.exports = __webpack_public_path__ + "img/lens-150-minus-08.5db65cdf.png";